import { ButtonBase, Typography, useTheme } from "@mui/material"
import { SearchIcon } from "../../icons"

export const SearchToggleButton = ({ placeholder = "Search", onClick }) => {
  const theme = useTheme()
  const styleOverrides =
    theme.components[`VuiSearchToggleButton`]?.styleOverrides || {}
  const { root, searchIcon, label } = styleOverrides
  return (
    <ButtonBase variant="outlined" sx={root} onClick={onClick}>
      <SearchIcon sx={searchIcon} />
      <Typography sx={label}>{placeholder}</Typography>
    </ButtonBase>
  )
}
